import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideContactUs() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">


        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お問い合わせ
          </Typography>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={6}>
                <CustomButton href="/contactus" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お問い合わせはこちら
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomButton href="/guide-terms" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  規約
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

      </div>
    </div>
  );
}

export default GuideContactUs;
